import React from "react";
import "./WhyUs.css";

const WhyUs = () => {
  return (
    <section id="why-main-container">
      <div className="row align-items-center">
        <div className="centered-container">
          <h2
            className="section-heading"
            data-aos="zoom-in-down"
            data-aos-delay="100"
            data-aos-duration="900"
          >
            How To Work COSMICAL EVENT PLANNERS
          </h2>
          <p
            className="section-para text-border"
            data-aos="zoom-in-up"
            data-aos-delay="150"
            data-aos-duration="900"
          >
            "Explore the most enchanting locations for your perfect day."
          </p>
        </div>
      </div>
      <div className="why-us-container">
        <div className="video-section">
          <video  autoPlay loop muted controls className="video-player">
            <source src="assets/cep-intro.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="info-section">
          <h2> COSMICAL EVENT PLANNERS</h2>

          <div className="info-item">
            <div className="icon">🌸</div>
            <div className="text">
              <h3>Offers to our most trusted brand -</h3>
              <p>
                Our Customers Right from the start, Cosmical Event Planners is
                dedicated to making every aspect of your momentous celebrations
                a success. Alongside our uncompromised cooperation and prompt
                actions, we assist you with the following: Budgeting: We take on
                one of the most arduous tasks of event planning — budget
                allocation. Based on your requirements, we provide expert
                guidance to ensure efficient distribution among vendors. Vendor
                Recommendation: Using our AI-enabled software, we analyze your
                budget and present a curated list of the most suitable vendors
                for essential services. Price Negotiation: Our team supports you
                during critical price negotiations, ensuring you secure
                efficient and fair deals that fit your budget. Event
                Coordination: Our dedicated event coordinator manages all
                on-the-ground activities on your big day, so you can relax and
                enjoy every moment without stress. Post-Event Evaluation: Your
                feedback is invaluable to us. It helps us refine our services
                and continue delivering exceptional experiences for future
                events.
              </p>
            </div>
          </div>
          {/* <div className="info-item">
            <div className="icon">🌸</div>
            <div className="text">
              <h3>New-Age Methodologies</h3>
              <p>
                We continuously thrive in the changing landscape of learning. We
                design immersive learning experiences using pedagogies like
                Lego, Art, Dance, Music, Cooking, Storytelling, Games, Movies to
                Simulation based, Human Lab based learnings.
              </p>
            </div>
          </div>
          <div className="info-item">
            <div className="icon">🌸</div>
            <div className="text">
              <h3>Deep & Immersive Content Design</h3>
              <p>
                NeuCode places a strong emphasis on developing emotional
                intelligence and growth mindset. We utilize latest researched
                concepts from Neuroscience, NLP, Transactional Analysis,
                Emotional intelligence & Org/Behavioral/Social psychology.
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
